import React from "react";
import { toast } from "react-toastify";

const NotFound = () => {
  const notification = (text) => {
    const raisetoast = (
      <p style={{ fontWeight: "700", color: "Black" }}>{text}</p>
    );
    toast(raisetoast);
  };
  return (
    <div className="notFound" style={{display: 'flex', justifyContent:"center", marginTop: "40vh"}}>
      <h2>Page Not Found </h2>
      {notification("Page Not Found")}
    </div>
  );
};

export default NotFound;
